import React, { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import Select from 'react-select'
import './Select.scss'

const SelectComponent = (
  {
    className,
    select,
    optionSelect,
    label,
    labelColor,
    options,
    error,
    name,
    onChange,
    placeholder,
    shouldTranslate,
    requiredField,
    dropdownIndicator,
    value,
    ...restProps
  },
) => {
  const { t } = useTranslation('common_volunteering')
  const memoT = useCallback((val) => t(val), [t])

  const handleChange = useCallback(
    (val) => onChange(val, name),
    [onChange, name],
  )

  let newArr = []
  if (shouldTranslate) {
    newArr = options.map((item) => {
      const label = t(item.label)
      return { ...item, label }
    })
  }

  const components = dropdownIndicator ? {
    IndicatorSeparator: () => null,
    DropdownIndicator: () => null,
  } : {
    IndicatorSeparator: () => null,
  }

  return (
    <div
      className={clsx(
        'select-control d-flex flex-column',
        className,
      )}>
      <div className="d-flex justify-content-between">
        <span
          className={clsx(
            labelColor,
            error && 'select-error-text',
          )}>
          {memoT(label)}
        </span>
        {requiredField && (
          <span className={clsx(
            labelColor,
            error && 'select-error-text',
            'd-flex justify-content-end',
          )}>
            {memoT('mandatory')}
          </span>
        )}
      </div>

      <Select
        noOptionsMessage={() => null}
        components={components}
        options={shouldTranslate ? newArr : options}
        className={clsx(
          select,
          'react-select',
          error && 'select-error',
        )}
        classNamePrefix={optionSelect}
        placeholder={memoT(placeholder)}
        onChange={handleChange}
        value={value}
        {...restProps}
      />
    </div>
  )
}

SelectComponent.propTypes = {
  select: PropTypes.oneOf(['primary-select', 'custom']),
  optionSelect: PropTypes.oneOf(['primary-option', 'custom']),
  labelColor: PropTypes.string,
  options: PropTypes.array,
  className: PropTypes.string,
  error: PropTypes.any,
}

SelectComponent.defaultProps = {
  select: 'primary-select',
  optionSelect: 'primary-option',
  label: '',
  labelColor: 'primary-label',
  options: [],
  className: '',
  error: '',
}

export default memo(SelectComponent)
